import { BaseMatcher, Matcher } from './base.matcher';

export function hasText(message: () => string = () => 'value must have text'): Matcher<string> {
  return new BaseMatcher<string>((input) => {
    return input.trim().length > 0;
  }, message);
}
